import React from 'react';

export const SequenceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_1544_17419)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2007 10.2352C13.2007 9.22159 14.0224 8.3999 15.036 8.3999H26.9654C27.979 8.3999 28.8007 9.22159 28.8007 10.2352V22.1646C28.8007 23.1782 27.979 23.9999 26.9654 23.9999H15.036C14.0224 23.9999 13.2007 23.1782 13.2007 22.1646V10.2352Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.8008 11C32.3531 11 32.8008 11.4477 32.8008 12V25.5C32.8008 26.8807 31.6815 28 30.3008 28H16.8008C16.2485 28 15.8008 27.5523 15.8008 27C15.8008 26.4477 16.2485 26 16.8008 26H30.3008C30.5769 26 30.8008 25.7762 30.8008 25.5V12C30.8008 11.4477 31.2485 11 31.8008 11Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1544_17419"
          x="0.800781"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1544_17419" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1544_17419" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
